import Connection from "../../modules/connection/views/Connection.vue";
import RouterViewRender from "../../utils/routes/router-view-render";
import PreviewContent from "../../modules/connection/views/PreviewContent.vue";

const ConnectionRoutes = {
  path: "conexao",
  component: RouterViewRender,   
  children: [
    {
      path: "",
      component: Connection,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "visualizacao/:id",
      component: PreviewContent,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default ConnectionRoutes;
